import React, { useState } from "react";
import PropTypes from "prop-types";
import FieldInput from "../../atoms/field-input";
import { WebEngage, GA, PGAD } from "../../../integrations";
import { PAGE_TYPE } from "../../../constants";
import Icon from "../../atoms/icon";
import styles from "./styles.m.css";
import { VikatanAsidebar } from "../../rows/ad-free";

const TaxPage = ({ data }) => {
  const [age, setAge] = useState("under-age");
  const [salaried, setSalaried] = useState("yes");
  const [totalNewTaxgross, setTotalNxtTaxgross] = useState(0);
  const [totalExtTaxgross, setTotalExtTaxgross] = useState(0);
  const [OLDRegimetotal, setOLDRegimetotal] = useState(0);
  const [NEWRegimetotal, setNEWRegimetotal] = useState(0);
  const standardDeductionNew = salaried === "yes" ? 50000 : 0;

  const [GTIncomeNew, setGTIncomeNew] = useState(0);
  const [GTIncomeExt, setGTIncomeExt] = useState(0);
  const [HRAExNew, setHRAExNew] = useState(0);
  const [US80CNew, setUS80CNew] = useState(0);
  const [US80CCDNew, setUS80CCDNew] = useState(0);
  const [US80ENew, setUS80ENew] = useState(0);
  const [US80DNew, setUS80DNew] = useState(0);
  const [HRAexpop, setHRAexpop] = useState(0);
  const [result, setResult] = useState(false);
  const [Homeloanint, setHomeloanint] = useState(0);
  const [fy, setFy] = useState("new");
  const standardDeductionExt = fy === "new" ? (salaried === "yes" ? 50000 : 0) : 0;

  React.useEffect(() => {
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.TAX_PAGE, { collection: data.collection });
    PGAD.loadScript();
  }, []);

  const handleSetAge = e => {
    setAge(e.target.value);
    setUS80DNew(0);
  };

  const handleFy = e => {
    setFy(e.target.value);
    setTotalNxtTaxgross(0);
    setTotalExtTaxgross(0);
    setGTIncomeExt(0);
    setGTIncomeNew(0);
  };

  const handlesetSalaried = e => {
    setSalaried(e.target.value);
    setHRAExNew(0);
  };

  const handleTotalGross = value => {
    const ftStandardDec = fy === "new" ? parseInt(value > 50000 ? value - standardDeductionNew : 0) : parseInt(value);
    setTotalNxtTaxgross(value);
    setTotalExtTaxgross(value);
    setGTIncomeExt(ftStandardDec);
    setGTIncomeNew(parseInt(value > 50000 ? value - standardDeductionNew : 0));
  };

  const handleHRAex = value => {
    setHRAExNew(value);
    setHRAexpop(false);
  };

  const handleCalculate = () => {
    // old regime cal
    const us80cInclude = age === "under-age" ? 25000 : 30000;
    const OLDRegime =
      parseInt(GTIncomeNew) -
      parseInt(HRAExNew) -
      restrictValue(US80CNew, 150000) -
      restrictValue(US80CCDNew, 50000) -
      restrictValue(US80DNew, us80cInclude) -
      restrictValue(Homeloanint, 200000) -
      parseInt(US80ENew);

    const ORtaxableAmount =
      age === "under-age"
        ? formulaOldregimeB60(OLDRegime)
        : age === "senior-citizen"
          ? formulaOldregimeSC(OLDRegime)
          : formulaOldregimeVSC(OLDRegime);
    const ORrebate = OLDRegime > 500000 ? 0 : 12500;
    const ORtaxAmount = parseInt(ORtaxableAmount) + parseInt(ORrebate);
    const ORcess = (ORtaxAmount * 4) / 100;
    const ORTotalTax = OLDRegime > 500000 ? parseInt(ORtaxAmount + ORcess) : 0;

    // new regime calculation
    const NEWRegime = parseInt(GTIncomeExt);
    const NRtaxableAmount =
      fy === "new" ? (NEWRegime <= 700000 ? 0 : formulaNewregime(NEWRegime)) : formulaNewregime2022(NEWRegime);

    const NRrebate = 0;
    const NRtaxAmount = parseInt(NRtaxableAmount) + parseInt(NRrebate);
    const NRcess = (NRtaxAmount * 4) / 100;
    const NRTotalTax = parseInt(NRtaxAmount + NRcess);

    setNEWRegimetotal(NRTotalTax);
    setOLDRegimetotal(ORTotalTax);
    setResult(true);
    window.scrollTo({
      top: 150,
      behavior: "smooth"
    });
  };

  const restrictValue = (value, setValue) => {
    return parseInt(value > setValue ? setValue : value);
  };

  const formulaNewregime = args => {
    return args < 300000
      ? 0
      : args <= 600000
        ? parseInt(((args - 300000) * 5) / 100)
        : args <= 900000
          ? parseInt(((args - 600000) * 10) / 100) + 15000
          : args <= 1200000
            ? parseInt(((args - 900000) * 15) / 100) + 45000
            : args <= 1500000
              ? parseInt(((args - 1200000) * 20) / 100) + 90000
              : args > 1500000
                ? parseInt(((args - 1500000) * 30) / 100) + 150000
                : 0;
  };

  const formulaNewregime2022 = args => {
    return args < 250000
      ? 0
      : args <= 500000
        ? parseInt(((args - 250000) * 5) / 100)
        : args <= 750000
          ? parseInt(((args - 500000) * 10) / 100) + 12500
          : args <= 1000000
            ? parseInt(((args - 750000) * 15) / 100) + 37500
            : args <= 1250000
              ? parseInt(((args - 1000000) * 20) / 100) + 75000
              : args <= 1500000
                ? parseInt(((args - 1250000) * 25) / 100) + 125000
                : args > 1500000
                  ? parseInt(((args - 1500000) * 30) / 100) + 187500
                  : 0;
  };

  const formulaOldregimeB60 = args => {
    return args < 250000
      ? 0
      : args <= 500000
        ? parseInt(((args - 250000) * 5) / 100)
        : args <= 1000000
          ? parseInt(((args - 500000) * 20) / 100) + 12500
          : args > 1000000
            ? parseInt(((args - 1000000) * 30) / 100) + 112500
            : 0;
  };

  const formulaOldregimeSC = args => {
    return args < 300000
      ? 0
      : args <= 500000
        ? parseInt(((args - 300000) * 5) / 100)
        : args <= 1000000
          ? parseInt(((args - 500000) * 20) / 100) + 10000
          : args > 1000000
            ? parseInt(((args - 1000000) * 30) / 100) + 110000
            : 0;
  };

  const formulaOldregimeVSC = args => {
    return args < 500000
      ? 0
      : args <= 1000000
        ? parseInt(((args - 500000) * 20) / 100)
        : args > 1000000
          ? parseInt(((args - 1000000) * 30) / 100) + 100000
          : 0;
  };

  const numberWithCommas = x => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <React.Fragment>
      <div className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]}`}>
        <div />
        <div className="page-content infinity-page">
          <div className={`container ${styles["story-grid"]}`}>
            <div className={`${styles["main-container"]}`}>
              {/*
                <div className={`${styles["translate-wrapper"]}`}>
                  <div className={`${styles["translate"]}`}>
                    <span className={`${styles["active"]}`}>Tamil</span>
                    <span>English</span>
                  </div>
                </div>
              */}
              <h1>வருமான வரி கால்குலேட்டர் </h1>

              <div className={`${styles["tax-content-wrapper"]}`}>
                {!result && (
                  <div className={`${styles["fy-container"]}`}>
                    <h3 className={`${styles["fy-title"]}`}>கணக்கிட விரும்பும் நிதியாண்டு</h3>
                    <div className={`${styles["fy-grid"]}`}>
                      <div className={`${styles["fy-div"]}  ${styles["fy-div-one"]}`}>
                        <div className={`${styles["fy-input"]}`}>
                          <div className={`${styles["fy-div-radio-2023"]}`}>
                            <input
                              type="radio"
                              checked={fy === "old"}
                              onClick={handleFy}
                              value="old"
                              id="fy1"
                              name="radio-group-fy"
                            />{" "}
                            <label htmlFor="fy1">FY 2022-2023</label>
                          </div>
                        </div>
                        <span>2023 பட்ஜெட்டுக்கு முன்</span>
                      </div>
                      <div className={`${styles["fy-div"]} ${styles["fy-div-second"]}`}>
                        <div className={`${styles["fy-input"]}`}>
                          <div className={`${styles["fy-div-radio-2024"]}`}>
                            <div className={`${styles["fy-div-radio"]}`}>
                              <input
                                type="radio"
                                checked={fy === "new"}
                                onClick={handleFy}
                                value="new"
                                id="fy2"
                                name="radio-group-fy"
                              />{" "}
                              <label htmlFor="fy2" />
                            </div>
                            <div className={`${styles["year-tax"]}`}>
                              FY 2023-2024 <i className={`${styles["new-update-tag"]}`}>New Update</i>
                            </div>
                          </div>
                        </div>
                        <span> 2023 பட்ஜெட்டுக்குப் பின் </span>
                      </div>
                    </div>
                  </div>
                )}

                {!result && (
                  <div className={`${styles["age-container"]}`}>
                    <h3 className={`${styles["age-title"]}`}>வயது வரம்பு</h3>
                    <div className={`${styles["age-grid"]}`}>
                      <div className={`${styles["age-div"]}`}>
                        <div className={`${styles["age-input"]}`}>
                          <input
                            type="radio"
                            checked={age === "under-age"}
                            onClick={handleSetAge}
                            value="under-age"
                            id="radio1"
                            name="radio-group"
                          />{" "}
                          <label htmlFor="radio1">60</label>
                          <Icon type="arrow-down" className={`${styles["age-arrow"]}`} />
                        </div>
                        <span>
                          வயதுக்குக் கீழ் <i>(Under 60 Years)</i>
                        </span>
                      </div>
                      <div className={`${styles["age-div"]}`}>
                        <div className={`${styles["age-input"]}`}>
                          <input
                            type="radio"
                            checked={age === "senior-citizen"}
                            onClick={handleSetAge}
                            value="senior-citizen"
                            id="radio2"
                            name="radio-group"
                          />{" "}
                          <label htmlFor="radio2">60-79</label>
                        </div>
                        <span>
                          வயது வரை <i>(Senior Citizen)</i>
                        </span>
                      </div>
                      <div className={`${styles["age-div"]}`}>
                        <div className={`${styles["age-input"]}`}>
                          <input
                            type="radio"
                            checked={age === "very-senior-citizen"}
                            onClick={handleSetAge}
                            value="very-senior-citizen"
                            id="radio3"
                            name="radio-group"
                          />{" "}
                          <label htmlFor="radio3">80 </label>
                          <Icon type="arrow-up" className={`${styles["age-arrow"]}`} />
                        </div>
                        <span>
                          வயதுக்கு மேல் <i>(Very Senior Citizen)</i>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                <div className={`${styles["form-tax-label"]}`}>
                  <div className={`${styles["current-tax-label"]}`}>
                    <span>
                      நிதி ஆண்டு <i>(Financial Year)</i>
                    </span>
                  </div>
                  <div className={`${styles["current-tax"]}`}>
                    <span>
                      தற்போதைய <br />
                      வரிமுறை <i>(Old Tax Regime)</i>
                    </span>
                    <span>
                      புதிய <br />
                      வரிமுறை <i>(New Tax Regime)</i>
                    </span>
                  </div>
                </div>
                {!result ? (
                  <div className={styles["main-form"]}>
                    <div className={styles["field-outer"]}>
                      <label>
                        நீங்கள் சம்பளதாரரா? <i>(Are you a salaried employee?)</i>
                      </label>
                      <div className={styles["field-left"]}>
                        <div>
                          <input
                            type="radio"
                            checked={salaried === "yes"}
                            onClick={handlesetSalaried}
                            value="yes"
                            id="taxone"
                            name="radio-group-one"
                          />
                          <label htmlFor="taxone">
                            <span>ஆம்</span>
                          </label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            checked={salaried === "no"}
                            onClick={handlesetSalaried}
                            value="no"
                            id="taxtwo"
                            name="radio-group-one"
                          />
                          <label htmlFor="taxtwo">
                            <span>இல்லை</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <FieldInput
                      name="totalgross"
                      label="மொத்த வருமானம்"
                      infoText="(Gross income)"
                      newTax={totalNewTaxgross}
                      extTax={totalExtTaxgross}
                      updateField={value => handleTotalGross(value)}
                      tooltip="உள்ளடக்கியவை: சம்பளம், வட்டி வருமானம்,  வீட்டு வாடகை  வருமானம் ( வீட்டுக் கடன் மாதத் தவணை போக), குறுகிய கால மூலதன ஆதாயங்கள் போன்றவை வழக்கமான  வரி விகிதத்தில் வரி விதிக்கப்படும்."
                    />
                    <FieldInput
                      name="standardDeduction"
                      label="நிலைக்கழிவு"
                      infoText="(Standard Deduction)"
                      newTax={standardDeductionNew}
                      extTax={standardDeductionExt}
                      readOnly={true}
                    />
                    <FieldInput
                      name="GTIncome"
                      label="மொத்த வரிக்கு உட்பட்ட வருமானம்"
                      infoText="(Gross taxable income)"
                      newTax={GTIncomeNew}
                      extTax={GTIncomeExt}
                    />
                    {salaried === "yes" && (
                      <div className={`${styles["hra-relative"]}`}>
                        <FieldInput
                          name="HRAEx"
                          label="வீட்டு வாடகைப்படி விலக்கு"
                          infoText="(HRA exemption)"
                          newTax={HRAExNew}
                          extTax={"N/A"}
                          updateField={value => setHRAExNew(value)}
                        />
                        {!HRAexpop ? (
                          <span onClick={() => setHRAexpop(true)} className={`${styles["hra-label"]}`}>
                            வீட்டு வாடகைப்படி விலக்கு கணக்கீடு <i>(CALCULATE HRA EXEMPTION)</i>
                          </span>
                        ) : (
                          <HRACalculationForm actionAandleHRAex={handleHRAex} actionClose={() => setHRAexpop(false)} />
                        )}
                      </div>
                    )}
                    <FieldInput
                      name="US80C"
                      label="80-சி பிரிவின் கீழ் வரி விலக்குகள்"
                      infoText="(Deduction under section 80C)"
                      newTax={US80CNew}
                      extTax={"N/A"}
                      updateField={value => {
                        const valurest = restrictValue(value, 150000);
                        setUS80CNew(value !== "" ? valurest : 0);
                      }}
                      tooltip="உள்ளடக்கியவை: ஆயுள் காப்பீடு பிரீமியம், பி.எஃப் பங்களிப்பு, வீட்டுக் கடன் அசல் திருப்பிச் செலுத்துதல், குழந்தைகளுக்கான கல்வி கட்டணம் அதிகப்பட்ச வரிச் சலுகை  ₹1.5  லட்சம்"
                    />
                    <FieldInput
                      name="US80CCD"
                      label="பிரிவு 80 சிசிடி (1 பி) - NPS"
                      infoText="(Deduction under section 80CCD(1B))"
                      newTax={US80CCDNew}
                      extTax={"N/A"}
                      updateField={value => {
                        const valurest = restrictValue(value, 50000);
                        setUS80CCDNew(value !== "" ? valurest : 0);
                      }}
                      tooltip="தேசிய ஓய்வூதிய திட்டம் (என்.பி.எஸ்) உங்கள் பங்களிப்பு அதிகபட்ச கழித்தல் ₹ 50,000"
                    />
                    <FieldInput
                      name="US80CD"
                      label="பிரிவு 80 டி இன் கீழ் கழித்தல்"
                      infoText="(Deduction under section 80D)"
                      newTax={US80DNew}
                      extTax={"N/A"}
                      updateField={value => {
                        const us80cInclude = age === "under-age" ? 25000 : 30000;
                        const valurest = restrictValue(value, us80cInclude);
                        setUS80DNew(value !== "" ? valurest : 0);
                      }}
                      tooltip="உள்ளடக்கியவை: மருத்துவக் காப்பீடு அதிகபட்ச விலக்கு ₹ 25,000, மூத்த குடிமகன் ₹ 30,000"
                    />
                    <FieldInput
                      name="US80CE"
                      label="பிரிவு 80E இன் கீழ் கழித்தல்"
                      infoText="(Deduction under Section 80E)"
                      newTax={US80ENew}
                      extTax={"N/A"}
                      updateField={value => setUS80ENew(value)}
                      tooltip="உள்ளடக்கியவை: கல்விக்கடனுக்காக செலுத்திய வட்டி"
                    />
                    <FieldInput
                      name="homeloanint"
                      label="வீட்டுக் கடன் வட்டி"
                      infoText="(Deduction under Section 24)"
                      newTax={Homeloanint}
                      extTax={"N/A"}
                      updateField={value => {
                        const valurest = restrictValue(value, 200000);
                        setHomeloanint(value !== "" ? valurest : 0);
                      }}
                      tooltip="உள்ளடக்கியவை: அதிகபட்ச விலக்கு ₹ 2,00,000"
                    />
                    <div className={`${styles["tax-button"]}`} onClick={() => handleCalculate()}>
                      <button>Calculate</button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className={`${styles["form-tax-label"]} ${styles["total-tax"]}`}>
                      <label>
                        நீங்கள் செலுத்த வேண்டிய மொத்த வரி <i>(Your total tax payable)</i>
                      </label>
                      <div className={styles["current-tax"]}>
                        <span>
                          <strong>
                            <Icon type="rupee" className={`${styles["rupee-icon"]}`} />
                            {numberWithCommas(OLDRegimetotal)}
                          </strong>
                        </span>
                        <span>
                          <strong>
                            <Icon type="rupee" className={`${styles["rupee-icon"]}`} />
                            {numberWithCommas(NEWRegimetotal)}
                          </strong>
                        </span>
                      </div>
                    </div>
                    <div className={styles["notify-op"]}>
                      {OLDRegimetotal >= NEWRegimetotal ? (
                        <div className={styles["green"]}>
                          புதிய வரிமுறையைத் தேர்வு செய்தால் இப்போது நீங்கள்,{" "}
                          <Icon type="rupee" className={`${styles["rupee-icon-tax"]}`} />
                          <span>{numberWithCommas(OLDRegimetotal - NEWRegimetotal)} </span> சேமிப்பீர்கள்.
                          <i>
                            (You will now save ₹{numberWithCommas(OLDRegimetotal - NEWRegimetotal)} if you opt for the
                            new tax regime.)
                          </i>
                        </div>
                      ) : (
                        <div className={styles["red"]}>
                          புதிய வரிமுறையைத் தேர்வு செய்தால் நீங்கள், ₹
                          <span>{numberWithCommas(NEWRegimetotal - OLDRegimetotal)}</span> கூடுதலாக வரி செலுத்த
                          வேண்டும்.
                          <i>
                            (You will have to pay ₹{numberWithCommas(NEWRegimetotal - OLDRegimetotal)} more if you opt
                            for the new tax regime.)
                          </i>
                        </div>
                      )}
                      <div className={`${styles["tax-button"]}`}>
                        <button onClick={() => setResult(false)}>Re-Calculate</button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className={`${styles["info"]}`}>
                <h2>பட்ஜெட் 2023 மாற்றங்கள்</h2>
                <ul>
                  <li>சம்பளத்தின் மீதான நிலை கழிவு - ரூ.50,000 புதிய வரிமுறையில் தற்போது சேர்க்கப்பட்டுள்ளது.</li>
                  <li>
                    உங்கள் வருமானம் 7,00,000 அல்லது அதற்கு குறைவாக இருப்பின், புதிய வரிமுறையின் கீழ் வரி எதுவும் கட்டத்
                    தேவையில்லை.
                  </li>
                  <li>
                    புதிய வரிமுறையில் வரி விதிப்பிற்கான வருமான அடுக்கில் மாற்றம் செய்யப்பட்டுள்ளது (விவரம் கீழே
                    தரப்பட்டுள்ளது).
                  </li>
                  <li>பழைய வரிமுறையில் தற்போது எந்த மாற்றமும் செய்யப்படவில்லை.</li>
                  <li>
                    வரிதாரர்கள் பழைய வரிமுறை மற்றும் புதிய வரிமுறை ஆகிய இரண்டில் ஒன்றைத் தேர்ந்தெடுத்துக் கொள்ளலாம்.
                  </li>
                </ul>
                <p>
                  வீட்டுப் வாடகைப்படி, பயண சலுகை விடுப்பு, தொழில்றை வரி மற்றும் VI-A இன் கீழ் கிடைக்கும் பெரும்பாலான
                  விலக்குகள், 80C (ஆயுள் காப்பீடு போன்றவை), 80 சிசிடி (1 பி) (என்.பி.எஸ்ஸில் ரூ .50,000 வரை உங்கள்
                  பங்களிப்பு), 80 டி (மருத்துவ காப்பீடு), 80 இ (கல்வி கடனுக்கான வட்டி) போன்றவை.புதிய எளிமைப்படுத்தப்பட்ட
                  வருமான வரி முறையின் கீழ் சுமார் 70 விலக்குகள் நீக்கப்பட்டிருக்கின்றன.
                </p>
                {/* <Icon type="rupee" className={`${styles["rupee-icon-tax"]}`} />
                3,00,000 வரை - வரி இல்லை{" "}
                <div>
                  <Icon type="rupee" className={`${styles["rupee-icon-tax"]}`} />
                  3,00,001 முதல் <Icon type="rupee" className={`${styles["rupee-icon-tax"]}`} />
                  6,00,000 - 5%{" "}
                </div>
                <div>
                  <Icon type="rupee" className={`${styles["rupee-icon-tax"]}`} />
                  6,00,001 முதல் <Icon type="rupee" className={`${styles["rupee-icon-tax"]}`} />
                  9,00,000 - 10%{" "}
                </div>
                <div>
                  <Icon type="rupee" className={`${styles["rupee-icon-tax"]}`} />
                  9,00,001 முதல் <Icon type="rupee" className={`${styles["rupee-icon-tax"]}`} />
                  12,00,000 - 15%{" "}
                </div>
                <div>
                  <Icon type="rupee" className={`${styles["rupee-icon-tax"]}`} />
                  12,00,001 முதல் <Icon type="rupee" className={`${styles["rupee-icon-tax"]}`} />
                  15,00,000 - 20%{" "}
                </div>
                <Icon type="rupee" className={`${styles["rupee-icon-tax"]}`} />
                15,00,000 -க்கு மேல் - 30% */}
                <table className={styles["income-tax-table"]}>
                  <tr>
                    <td colSpan={2}>
                      <h2>பழைய வரி விதிப்பு முறை</h2>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Income Slabs</strong>
                    </td>
                    <td>
                      <strong>Income Tax Rate</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>₹ 2,50,000 வரை</td>
                    <td>NIL</td>
                  </tr>
                  <tr>
                    <td>₹ 2,50,001 - ₹ 5,00,000 வரை</td>
                    <td>5%</td>
                  </tr>
                  <tr>
                    <td>₹ 5,00,001 - ₹ 10,00,000 வரை</td>
                    <td>20%</td>
                  </tr>
                  <tr>
                    <td>₹ 10,00,000-க்கு மேல்</td>
                    <td>30%</td>
                  </tr>
                </table>
                <table className={styles["income-tax-table"]}>
                  <tr>
                    <td colSpan={2}>
                      <h2>புதிய வரி விதிப்பு முறை (பட்ஜெட்டுக்கு முன்)</h2>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Income Slabs</strong>
                    </td>
                    <td>
                      <strong>Income Tax Rate</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>₹ 2,50,000 வரை</td>
                    <td>NIL</td>
                  </tr>
                  <tr>
                    <td>₹ 2,50,001 - ₹ 5,00,000 வரை</td>
                    <td>5%</td>
                  </tr>
                  <tr>
                    <td>₹ 5,00,001 - ₹ 7,50,000 வரை</td>
                    <td>10%</td>
                  </tr>
                  <tr>
                    <td>₹ 7,50,001 - ₹ 10,00,000 வரை</td>
                    <td>15%</td>
                  </tr>
                  <tr>
                    <td>₹ 10,00,001 - ₹ 12,50,000 வரை</td>
                    <td>20%</td>
                  </tr>
                  <tr>
                    <td>₹ 12,50,001 - ₹ 15,00,000 வரை</td>
                    <td>25%</td>
                  </tr>
                  <tr>
                    <td>₹ 15,00,000-க்கு மேல்</td>
                    <td>30%</td>
                  </tr>
                </table>
                <table className={styles["income-tax-table"]}>
                  <tr>
                    <td colSpan={2}>
                      <h2>புதிய வரி விதிப்பு முறை (பட்ஜெட்டுக்குப் பின்)</h2>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Income Slabs</strong>
                    </td>
                    <td>
                      <strong>Income Tax Rate</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>₹ 3,00,000 வரை</td>
                    <td>NIL</td>
                  </tr>
                  <tr>
                    <td>₹ 3,00,001 - ₹ 6,00,000 வரை</td>
                    <td>5%</td>
                  </tr>
                  <tr>
                    <td>₹ 6,00,001 - ₹ 9,00,000 வரை</td>
                    <td>10%</td>
                  </tr>
                  <tr>
                    <td>₹ 9,00,001 - ₹ 12,00,000 வரை</td>
                    <td>15%</td>
                  </tr>
                  <tr>
                    <td>₹ 12,00,001 - ₹ 15,00,000 வரை</td>
                    <td>20%</td>
                  </tr>
                  <tr>
                    <td>₹ 15,00,000-க்கு மேல்</td>
                    <td>30%</td>
                  </tr>
                </table>
              </div>
              <div className={`${styles["bottom-info"]}`}>
                பொறுப்பு துறப்பு: இந்த வரி கால்குலேட்டர் சில அனுமானங்களின் கீழ் செயல்படுகிறது. எனவே, உங்கள் உண்மையான வரி
                பொறுப்பு வேறுபடலாம். வாசகர்கள் தகுந்த தொழில்முறை ஆலோசனையைப் பெற அறிவுறுத்தப்படுகிறார்கள்.
              </div>
            </div>
            <aside className={styles.sidebar}>
              <VikatanAsidebar />
            </aside>
          </div>
        </div>

        <div />
      </div>
    </React.Fragment>
  );
};

const HRACalculationForm = props => {
  const [metro, setMetro] = useState("yes");
  const [basicSalary, setBasicSalary] = useState(0);
  const [DAllowance, setDAllowance] = useState(0);
  const [HRecived, setHRecived] = useState(0);
  const [AnRent, setAnRent] = useState(0);

  const handleHrCalculate = () => {
    const metroPercent = metro === "yes" ? 50 : 40;
    const basicTotal = parseInt(basicSalary) + parseInt(DAllowance);
    const DA = (basicTotal * metroPercent) / 100;
    const Acrent = parseInt(AnRent) - (basicTotal * 10) / 100;
    const maxValue = Math.min(Acrent, HRecived, DA);
    props.actionAandleHRAex(maxValue);
  };

  const handlesetmetro = e => {
    setMetro(e.target.value);
  };

  return (
    <React.Fragment>
      <div className={styles["hra-grid"]}>
        <div className={styles["hra-grid-form"]}>
          <h2>வீட்டு வாடகைப்படி விலக்கு கணக்கீடு</h2>
          <div className={styles["close-div"]} onClick={() => props.actionClose()}>
            X
          </div>
          <div className={styles["field-outer"]}>
            <label>
              அடிப்படை சம்பளம்
              <i>(Basic salary (Annual)</i>
            </label>
            <div className={styles["field-left"]}>
              <input
                type="text"
                value={basicSalary === 0 ? "" : basicSalary}
                onChange={e => {
                  const re = /^[0-9\b]+$/;
                  if (e.target.value === "" || re.test(e.target.value)) {
                    setBasicSalary(e.target.value);
                  }
                }}
                className={styles["field"]}
                pattern="^[0-9]*$"
              />
            </div>
          </div>
          <div className={styles["field-outer"]}>
            <label>
              அகவிலைப் படி
              <i>(Dearness allowance)</i>
            </label>
            <div className={styles["field-left"]}>
              <input
                type="text"
                value={DAllowance === 0 ? "" : DAllowance}
                onChange={e => {
                  const re = /^[0-9\b]+$/;
                  if (e.target.value === "" || re.test(e.target.value)) {
                    setDAllowance(e.target.value);
                  }
                }}
                className={styles["field"]}
              />
            </div>
          </div>
          <div className={styles["field-outer"]}>
            <label>
              வீட்டு வாடகைப் படி
              <i>(HRA received)</i>
            </label>
            <div className={styles["field-left"]}>
              <input
                type="text"
                value={HRecived === 0 ? "" : HRecived}
                onChange={e => {
                  const re = /^[0-9\b]+$/;
                  if (e.target.value === "" || re.test(e.target.value)) {
                    setHRecived(e.target.value);
                  }
                }}
                className={styles["field"]}
              />
            </div>
          </div>
          <div className={styles["field-outer"]}>
            <label>
              செலுத்திய வாடகை
              <i>(Actual rent paid)</i>
            </label>
            <div className={styles["field-left"]}>
              <input
                type="text"
                value={AnRent === 0 ? "" : AnRent}
                onChange={e => {
                  const re = /^[0-9\b]+$/;
                  if (e.target.value === "" || re.test(e.target.value)) {
                    setAnRent(e.target.value);
                  }
                }}
                className={styles["field"]}
              />
            </div>
          </div>
          <div className={styles["field-outer"]}>
            <label>
              மெட்ரோ நகரில் வசிப்பவரா?
              <i>(Residing in metro?)</i>
            </label>
            <div className={`${styles["field-left"]} ${styles["hra-radio"]}`}>
              <div>
                <input
                  type="radio"
                  checked={metro === "yes"}
                  onClick={handlesetmetro}
                  value="yes"
                  id="tax-one"
                  name="metr-group-one"
                />
                <label htmlFor="tax-one">
                  <span>ஆம்</span>
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  checked={metro === "no"}
                  onClick={handlesetmetro}
                  value="no"
                  id="tax-two"
                  name="metr-group-one"
                />
                <label htmlFor="tax-two">
                  <span>இல்லை</span>
                </label>
              </div>
            </div>
            <div className={`${styles["tax-button"]}`}>
              <button onClick={() => handleHrCalculate()}>Calculate</button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export { TaxPage };

TaxPage.propTypes = {
  data: PropTypes.shape()
};

HRACalculationForm.propTypes = {
  actionAandleHRAex: PropTypes.func,
  actionClose: PropTypes.func
};
